<template>
  <div class="wrapper single-page-wrap">
    <!-- <p>停车券发放记录-{{ couponName }}</p> -->
    <cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
      <!-- <no-data v-else msg="暂无"></no-data> -->

      <div class="fee-list-wrapper" v-if="recordList.length > 0">
        <div class="weui-cells-wrapper" v-for="item of recordList" :key="item.id">
          <div class="weui-cells">
            <!-- <div class="weui-cell">
              <div class="weui-cell__bd">
                <p>券名称</p>
              </div>
              <div class="weui-cell__ft">{{ couponName }}</div>
            </div> -->
<div class="weui-flex">
	<div class="weui-cell weui-cell_60">
              <div class="weui-cell__bd">
                <p>发放方式</p>
              </div>
              <div class="weui-cell__ft" v-if="item.bindMethod === 2">商家绑定车牌</div>
              <div class="weui-cell__ft" v-if="item.bindMethod === 3">商家手机号绑定</div>
              <div class="weui-cell__ft" v-if="item.bindMethod === 8">微信扫一扫</div>
            </div>
			
			<div class="weui-cell weui-cell_35">
              <div class="weui-cell__bd">
                <p>数量</p>
              </div>
              <div class="weui-cell__ft">{{ item.sendNum }}</div>
            </div>
</div>
            

		<div class="weui-flex">
			<div class="weui-cell weui-cell_60">
              <div class="weui-cell__bd">
                <p v-if="item.bindPhonenumber">手机号</p>
                <p v-else>车牌号</p>
              </div>
              <div v-if="item.bindPhonenumber" class="weui-cell__ft">
                {{ item.bindPhonenumber }}
              </div>
              <div v-else class="weui-cell__ft">{{ item.bindPlatenumber }}</div>
            </div>




			<div class="weui-cell weui-cell_35" >
              <div class="weui-cell__bd">
                <p>金额</p>
              </div>
              <div class="weui-cell__ft">{{ item.price }}</div>
            </div>
		</div>

        
			
          </div>
        </div>
      </div>
      <no-data v-else msg="暂无"></no-data>
    </cube-scroll>
    <!-- 
			<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
				<div class="fee-list-wrapper" v-if="recordList.length > 0">
					<div class="weui-cells-wrapper" v-for="item of recordList" :key="item.id">
						<div class="weui-cells">
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>停车场</p>
								</div>
								<div class="weui-cell__ft">456464</div>
							</div>
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>停车场</p>
								</div>
								<div class="weui-cell__ft">5664564</div>
							</div>
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>停车场</p>
								</div>
								<div class="weui-cell__ft">4987989</div>
							</div>
						
						</div>
					
					</div>
				</div>
				<no-data v-else msg="暂无"></no-data>
			</cube-scroll> -->
  </div>
</template>

<script>
import { getRecordByTaskId } from "../../../api/coupon/rationRecord";
import { mapGetters } from "vuex";

export default {
  name: "index",
  data() {
    return {
      recordList: [],
      couponName: null,
      scrollOptions: {
        click: true,
        bounce: false,
      },
    };
  },
  computed: {
    ...mapGetters(["userPhone", "taskId"]),
  },
  created() {
    this.$nextTick(() => {
      this.$refs.scroll.refresh();
    });
  

    this.getRecord();
  },
  mounted() {
	this.couponName = this.$route.params.couponName;
    this.setTitle("发券记录-"+this.couponName);
  },
  methods: {
    setTitle(title) {
      document.title = title;
      // 创建一个iframe，用来帮助刷新标题
      let iframe = document.createElement("iframe");
      iframe.style.display = "none"; // 防止iframe对布局产生影响
      // 使用任何存在的小图标
      iframe.onload = function () {
        setTimeout(function () {
          document.body.removeChild(iframe);
        }, 0);
      };
      document.body.appendChild(iframe);
    },

    getRecord() {
    //   let businessPhone = "17337823986";
      getRecordByTaskId({taskId: this.taskId,businessPhone:this.userPhone}).then(res =>{
    //   getRecordByTaskId({ taskId: this.taskId, businessPhone: businessPhone }).then((res) => {
          this.recordList = res.data;
        }
      );
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~common/stylus/variable';
.wrapper {
	/*padding-bottom 20px*/
	.weui-article{
		padding-bottom 0
		p {
			font-size $article-merchant-p
			color $article-p-color
			line-height 20px
		}
		.weui-cell_select-after{
			padding-left 0
		}
	}
	.weui-btn-area{
		margin-top 0
		.weui-btn_primary, .weui-btn_disabled{
			width 100%
		}
	}
	.fee-list-wrapper{
		.weui-cells-wrapper{
			/*background-color #fff*/
			/*padding 5px 0*/
			margin 5px 10px 10px 10px
			border-radius 10px
			box-shadow  0 0 5px #eee
			display flex
			border-bottom:1px solid rgba(0, 0, 0, 0.1);
			.icon-guoqi{
				font-size: 180px;
				opacity: .3;
				position: absolute;
				top: 10%;
			}
		}
		.weui-cells{
			width 100%
			margin-top 0
			border-top-left-radius 10px
			border-bottom-left-radius 10px
			padding 5px 0
			.weui-cell{
				padding-top 5px
				padding-bottom 5px
				.weui-cell__bd{
					
					font-size 12px
				}
				.weui-cell__ft{
				
					font-size 12px
					text-align left
				}
			}
			.weui-cell:before{
				border-top none!important
			}
		}
		.weui-cells:before{
			border-top: none!important
		}
		.weui-cells:after{
			border-bottom: none!important
		}
		.weui-btn-wrapper{
			width 24%
			padding 5px 0
			display flex
			flex-direction column
			justify-content space-around
			align-items center
			.weui-btn_default{
				font-size 13px
			}
			.weui-btn_mini{
				line-height 1.8
			}
		}
	}
	.cube-scroll{
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 95%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 50px
	}
}
.no-enter{
	position absolute
	top 0
	left 0
	right 0
	background-color #ffffff
	height 100%
	z-index 9999
	display flex
	justify-content center
	align-items center
	font-size 20px
	p{
		padding-bottom 70px
	}
}
.weui-flex{
	display:flex;
	
	.weui-cell_35{
		width:38%;
	}
	.weui-cell_60{
		width:60%;
	}
}
</style>
